import { ModalBody } from 'react-bootstrap';
import styled from 'styled-components';

export const MainHeading = styled.h1`
  font-weight: 700;
  font-size: 22px;
  line-height: calc(35 / 22);
  color: var(--neutral-10);
  margin-bottom: 24px;
`;

export const MailContentWrapper = styled.div`
  display: inline-block;
  cursor: pointer;
  font-size: 16px;
  line-height: calc(26 / 16);
  color: var(--neutral-10);

  &:hover {
    text-decoration: underline;
  }
`;

export const RecipientWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  svg path[stroke] {
    stroke: var(--primary);
  }

  p {
    color: var(--primary);

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const ModalContentBody = styled(ModalBody)`
  .sims-logo {
    height: 100%;
    max-height: 100%;
  }

  .main {
    width: 100%;
  }

  .table {
    table-layout: fixed;
  }
`;

export const ModalRecipitentBody = styled(ModalBody)`
  .card-header {
    min-height: 0;
  }

  tbody {
    tr:last-child {
      border-bottom: none !important;
    }
  }
`;

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const Card = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  padding: 48px;
  max-width: 480px;
  width: 100%;
  text-align: center;
`;

export const IconWrapper = styled.div<{ status: 'loading' | 'success' | 'error' }>`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
  background: ${(props) => {
    switch (props.status) {
      case 'success':
        return '#dcfce7';
      case 'error':
        return '#fee2e2';
      default:
        return '#dbeafe';
    }
  }};

  svg {
    width: 40px;
    height: 40px;

    path[stroke] {
      stroke: ${(props) => {
        switch (props.status) {
          case 'success':
            return '#16a34a';
          case 'error':
            return '#dc2626';
          default:
            return '#2563eb';
        }
      }};
    }
  }
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 16px;
  line-height: 1.2;
`;

export const Description = styled.p`
  font-size: 16px;
  color: #6b7280;
  margin-bottom: 32px;
  line-height: 1.6;
`;

export const Button = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background: #2563eb;
  color: white;

  &:hover {
    background: #1d4ed8;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const SuccessMessage = styled.div`
  background: #dcfce7;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
  color: #166534;
  font-size: 14px;
`;

export const ErrorMessage = styled.div`
  background: #fee2e2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
  color: #991b1b;
  font-size: 14px;
`;
